import { object, string, ref, type InferType } from "yup";
import {
  AchAccountOwnershipType,
  BankAccountType,
} from "../../../../graphql/supergraphOperations";
import { RoutingNumberNoBankAddressInputSchema } from "../BankValidators/RoutingNumberInput/constants";

export enum AchPaymentPrefInputFields {
  AccountHolderName = "accountHolderName",
  AccountNumber = "accountNumber",
  ConfirmAccountNumber = "confirmAccountNumber",
  AccountType = "accountType",
  OwnershipType = "ownershipType",
  AdditionalInstructions = "additionalInstructions",
}

export const NO_SELECTION = "no_selection";

export const nullableRadioButtonFactory = (radioButtonValues: string[]) => {
  return string()
    .oneOf([...radioButtonValues, NO_SELECTION], "Required field")
    .required("Required field")
    .test("validSelection", "Required field", (schema) => schema !== NO_SELECTION);
};

export const AchPaymentPrefInputSchema = RoutingNumberNoBankAddressInputSchema.concat(
  object().shape({
    [AchPaymentPrefInputFields.AccountHolderName]: string()
      .matches(
        /^[\x20-\x7E]*$/,
        "Account holder name can only include standard letters, numbers, and common punctuation marks.",
      )
      .required("Required field")
      .matches(/\S/, "Account holder name cannot be just spaces."),
    [AchPaymentPrefInputFields.AccountNumber]: string()
      .max(17, "Account number must be 17 characters or less")
      .matches(
        /^[-.a-zA-Z0-9]+$/,
        "The account number may contain only alphanumeric characters, dashes and periods",
      )
      .required("Required field"),
    [AchPaymentPrefInputFields.ConfirmAccountNumber]: string()
      .oneOf([ref("accountNumber")], "Must match account number")
      .required("Required field"),
    [AchPaymentPrefInputFields.AccountType]: nullableRadioButtonFactory(
      Object.values(BankAccountType),
    ),
    [AchPaymentPrefInputFields.OwnershipType]: nullableRadioButtonFactory(
      Object.values(AchAccountOwnershipType),
    ),
    [AchPaymentPrefInputFields.AdditionalInstructions]: string()
      .matches(
        /^[\x20-\x7E]*$/,
        "Additional Instructions can only include standard letters, numbers, and common punctuation marks.",
      )
      .max(80, "Must be 80 characters or less"),
  }),
);

export type AchPaymentPrefInputType = InferType<typeof AchPaymentPrefInputSchema>;
